<p>test-input-activity-view works!</p>
